import React, {useEffect} from "react";
import Header from "../../../../framework/layouts/Header";
import Footer from "../../../../framework/layouts/Footer";
import CoursesContainer from "./CoursesContainer";
import CoursesClassificationContainer from "./CourseClassificationContainer";


const Courses = () => {
    const mainUrl = window.location.pathname
    console.log(mainUrl)
    return(
        <React.Fragment>
            <Header>
                {mainUrl == '/misc/coursemanagement' ? (<CoursesContainer/>) : (<CoursesClassificationContainer/>) }
            </Header>
            <Footer/>
        </React.Fragment>
    );
}

export default Courses